import React from 'react'
import { v4 as uuidv4 } from 'uuid';

const SingleEducation = (props) => {
    return ( <>
        <div>
            <p className="subheading-text">{props.degree}{props.college !== '' && ' | '+props.college}{props.grade !== '' && ' | '+props.grade}{props.startDate !== '' && ' | '+props.startDate}{props.endDate !== '' && ' - '+props.endDate}</p>
            <p className="subpara-text">{props.university}</p>
        </div>
    </>)
}


function Education(props) {
    return (
        <>
            <section className="education">
                <p className="heading-text"> EDUCATION </p>
                {props.education.map((element)=>{
                    return <SingleEducation key={uuidv4()} {...element}/>
                })}
            </section>
        </>
    )
}

export default Education
